import React, { useState } from "react";
import { Link } from "react-scroll";
import { HiMenu, HiX } from "react-icons/hi";
import "../assets/css/Navbar.css";
import tefeenaLogo from "../assets/Images/tefeena-logo.png";


const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed top-0 w-full z-50 backdrop-blur-lg bg-black/50 border-b border-white/10 shadow-md">
      <div className="flex items-center justify-between px-6 md:px-12 py-4">
      
      <Link
  to="hero"
  smooth={true}
  duration={500}
  className="cursor-pointer flex items-center"
>
  <img
    src={tefeenaLogo}
    alt="Tefeena Logo"
    className="h-14 w-auto object-contain transition-transform duration-300 hover:scale-105"
  />
</Link>


        {/* Desktop Nav Links */}
        <div className="navbar-links">
          {["hero","about", "projects", "contact"].map((section) => (
            <Link
              key={section}
              to={section}
              smooth={true}
              duration={500}
              spy={true}
              offset={-70}
              className="nav-link"
              activeClass="active"
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
            </Link>
          ))}
        </div>

        {/* Mobile Toggle */}
        <div
          className="md:hidden text-white text-3xl transition-transform duration-300 hover:scale-110"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <HiX /> : <HiMenu />}
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && (
        <div className="md:hidden flex flex-col items-center bg-black/90 text-white py-6 space-y-6 text-lg font-semibold animate-fadeIn">
          {["hero","about", "projects", "contact"].map((section) => (
            <Link
              key={section}
              to={section}
              smooth
              duration={500}
              offset={-70}
              onClick={() => setIsOpen(false)}
              className="hover:text-[#D20062] transition-colors"
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
